import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "../../styles/ProductTabs.css";

function textToHtml(text = "") {
  return String(text || "")
    .trim()
    .replace(/\n/g, "<br />");
}

export default function ProductTabs({
  activeTab,
  onChangeTab,
  product,
  deliveryLines,
}) {
  const { t } = useTranslation("product");

  const code = useMemo(() => {
    const v = product?.variant_id || product?.product_id || product?.id;
    return v ? String(v) : "";
  }, [product]);

  const lines = deliveryLines?.length
  ? deliveryLines
  : t("delivery_text", { returnObjects: true });

  const infoHtml = useMemo(() => {
    const text = String(product?.description_text || "").trim();
    if (text) return textToHtml(text);

    const html = String(product?.description_html || "").trim();
    if (html) return html;

    return "";
  }, [product]);

  return (
    <>
      <div className="psTabs">
        <button
          type="button"
          className={`psTab ${activeTab === "info" ? "active" : ""}`}
          onClick={() => onChangeTab?.("info")}
        >
          {t("tab_info")}
        </button>

        <button
          type="button"
          className={`psTab ${activeTab === "delivery" ? "active" : ""}`}
          onClick={() => onChangeTab?.("delivery")}
        >
          {t("tab_delivery")}
        </button>

        {/* <button
          type="button"
          className={`psTab ${activeTab === "taste" ? "active" : ""}`}
          onClick={() => onChangeTab?.("taste")}
        >
          {t("tab_taste")}
        </button> */}
      </div>

      <div className="psTabContent">
        {activeTab === "info" && (
          <>
            {infoHtml ? (
              <div
                className="psDesc"
                dangerouslySetInnerHTML={{ __html: infoHtml }}
              />
            ) : (
              <p className="psDescEmpty">{t("description_empty")}</p>
            )}

            {!!code && (
              <div className="psInfoMeta">
                <span className="psInfoMetaLabel">{t("product_code")}</span>
                <span className="psInfoMetaValue">{code}</span>
              </div>
            )}

            {/* {Array.isArray(product?.tags) && product.tags.length > 0 && (
              <div className="psTags">
                {product.tags.map((tag) => (
                  <span key={tag} className="psTagChip">
                    {tag}
                  </span>
                ))}
              </div>
            )} */}
          </>
        )}

        {activeTab === "delivery" && (
          <div className="psDelivery">
            {lines.map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        )}

        {activeTab === "taste" && (
          <div className="psTaste">
            <p></p>
          </div>
        )}
      </div>
    </>
  );
}